import Request from '../../lib/exchange/request'
import RequestTypes from '../../lib/exchange-api/request-types'

class CmdCheckNewSoftwareRequest extends Request {
    constructor(mode) {
        super({
            req: RequestTypes.CMD_CHECK_NEW_SOFTWARE,
            req_id: 0
        });
    }
}

export default CmdCheckNewSoftwareRequest;